import { render } from "./웹진-파티마샘.vue?vue&type=template&id=98e9734e"
import script from "./웹진-파티마샘.vue?vue&type=script&lang=js"
export * from "./웹진-파티마샘.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__